<div class="bloq-goal shadow p-3 mb-5 bg-body-tertiary rounded">
  <div class="row">
    <div class="col-12">
      <h3 class="title">{{title}}</h3>
    </div>
    <div class="col-3 col-xs-12"><span class="number">{{returnDays(date1!)}}</span></div>
    <div class="col-7 d-flex align-items-center"><label for="" class="text-incident">DIAS SIN INCIDENTES
        PERSONALES</label></div>
    <div class="col-2 col-xs-12">
      <a class="btn btn-primary" data-bs-toggle="collapse" href="#collapseExample{{id1}}" role="button"
        aria-expanded="false" aria-controls="collapseExample">
        Ver
      </a>

    </div>

    <div class="collapse" id="collapseExample{{id1}}" style="width: 80%;margin: auto;overflow: hidden;">
      <div class="card card-body">
        {{description1}}
      </div>
    </div>
    <hr>
    <div class="col-3"><span class="number">{{returnDays(date2!)}}</span></div>
    <div class="col-7 d-flex align-items-center"><label for="" class="text-incident">DIAS SIN INCIDENTES
        AMBIENTALES</label></div>
    <div class="col-2 col-xs-12">
      <a class="btn btn-primary" data-bs-toggle="collapse" href="#collapseExample{{id2}}" role="button"
        aria-expanded="false" aria-controls="collapseExample">
        Ver
      </a>
    </div>
  </div>
  <div class="collapse" id="collapseExample{{id2}}" style="width: 80%;margin: auto; overflow: hidden;">
    <div class="card card-body">
      {{description2}}
    </div>
  </div>
</div>

<button #button type="button" *permission="['goals']"
  class="btn btn-primary btn-back position-absolute top-0 end-0 mt-2 me-2" (click)="presentModal()">
  <div class="second-back-section">
    <fa-icon [icon]="['far', 'edit']"></fa-icon>
  </div>
</button>

<p-dialog header="Editar {{title}}"  [appendTo]="'body'" [(visible)]="visible" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false"
  [resizable]="false">

  <div class="row">
    <p-divider align="left" type="solid" [style]="{'margin-bottom' : '0'}">
      <h6>DIAS SIN INCIDENTES PERSONALES</h6>
    </p-divider>
    <div class="col-12 mt-0">
      <label class="pl-2">Fecha de inicio</label>
      <p-calendar [(ngModel)]="dateString1" [maxDate]="hoy" placeholder="dd/mm/yyyy" [style]="{ width: '100%' }"
        appendTo="body"></p-calendar>
    </div>
    <div class="col-12 mt-0">
      <label class="pl-2">Descripción:</label>
      <textarea name="description" id="description" rows="3" class="form-control" [style]="{ width: '100%' }"
        placeholder="Agregue una breve descripción..." [(ngModel)]="description1"></textarea>
    </div>
  </div>

  <div class="row">
    <p-divider align="left" type="solid" [style]="{'margin-bottom' : '0'}">
      <h6>DIAS SIN INCIDENTES AMBIENTALES</h6>
    </p-divider>
    <div class="col-12 mt-0">
      <label for="expiration_date">Fecha de inicio</label>
      <p-calendar #calendar [(ngModel)]="dateString2" [maxDate]="hoy"  placeholder="dd/mm/yyyy" [style]="{ width: '100%' }"
        panelStyleClass="th" appendTo="body"></p-calendar>
    </div>
    <div class="col-12 mt-0">
      <label class="pl-2">Descripción:</label>
      <textarea name="description" id="description"  rows="3" class="form-control"
        placeholder="Agregue una breve descripción..." [(ngModel)]="description2"></textarea>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="text-end">
      <button class="btn btn-primary" (click)="onButtonClick()">Cargar</button>
    </div>
  </ng-template>
</p-dialog>